module.exports = __webpack_public_path__ + "img/card-offer-lemon.e65b87ca.png";